// test31
(31 && 0);
